// Если тебе пришло сообщение с уводом в другой канал
export const TRANSFER_TO_ANOTHER_COMMUNICATION_CHANNEL_INCOMING_TEXT =
  'Общаться за пределами Циан небезопасно: в других мессенджерах мы не сможем защитить вас от мошенников ';

// Если ты увел в другой канал
export const TRANSFER_TO_ANOTHER_COMMUNICATION_CHANNEL_OUTCOMING_TEXT =
  'Рекомендуем общаться на Циан — так безопаснее ';

export const INFO_MESSAGE_TEXT_MAP: { [flag: string]: { outcoming: string; incoming: string } } = {
  isTransferToAnotherCommunicationChannel: {
    incoming: TRANSFER_TO_ANOTHER_COMMUNICATION_CHANNEL_INCOMING_TEXT,
    outcoming: TRANSFER_TO_ANOTHER_COMMUNICATION_CHANNEL_OUTCOMING_TEXT,
  },
};
